import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { SectionHeading, smallInputCls, checkCls, outlineBtnCls } from './ui.jsx';

export default function AdditionalFieldsSection({ customFields, setCustomFields }) {
  const add = () =>
    setCustomFields([...customFields, { id: `field_${Date.now()}`, label: '', required: false }]);
  const update = (index, updates) =>
    setCustomFields(customFields.map((f, i) => (i === index ? { ...f, ...updates } : f)));
  const remove = (index) => setCustomFields(customFields.filter((_, i) => i !== index));

  return (
    <div className="space-y-3">
      <SectionHeading title="Additional fields" />

      <p className="text-xs text-white/60 leading-relaxed">
        Collect additional information when leads schedule an appointment with you. We already ask
        for your leads name, phone number and email address. There is no need to create fields for
        these.
      </p>

      <button type="button" data-testid="add-field" onClick={add} className={`${outlineBtnCls} flex items-center gap-1.5`}>
        <Plus className="w-3.5 h-3.5" />
        ADD FIELD
      </button>

      <div className="space-y-2.5 pt-1">
        {customFields.map((field, idx) => (
          <div key={field.id || idx} className="flex items-center gap-2">
            <div className="flex-1 relative">
              <input
                type="text"
                maxLength={40}
                required
                data-testid={`booking-page-custom-field-label-${idx}`}
                value={field.label}
                onChange={(e) => update(idx, { label: e.target.value })}
                placeholder="Field name"
                className={`${smallInputCls} pr-8`}
              />
              <button
                type="button"
                data-testid={`remove-field-${idx}`}
                onClick={() => remove(idx)}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-rose-400 hover:text-rose-300"
                title="Remove field"
              >
                <Trash2 className="w-3.5 h-3.5" />
              </button>
            </div>
            <label
              data-testid={`custom-field-is-required-${idx}`}
              className="flex items-center gap-1 text-xs text-white/80 select-none cursor-pointer"
            >
              <input
                type="checkbox"
                checked={Boolean(field.required)}
                onChange={(e) => update(idx, { required: e.target.checked })}
                className={checkCls}
              />
              <span>Required</span>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
